var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"spin"},[_c('div',{staticClass:"ring"},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('v-icon',{staticClass:"loader-bomberos"},[_vm._v(" $logoBomberos ")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }